'use strict';
var Matrix = require('ml-matrix');
var mersenneTwister = require('mersenne-twister');

//species are all dissolved substances in the equilibrium
//components are substances whose concentrations are independent variables determining all species concentrations
//as many formation reactions as species must be provided
//for each component, either total concentration or equilibrium concentration (to be kept fixed) must be provided. Solvent is an exception (see below)
//canonical ordering of input is key: precipitation reactions must be given last, coefficients of substances with fixed equilibrium concentrations come last
//columns of the coefficients matrix must match the elements of the equilibriumComponentConcentartions vector
//rows of the coefficients matrix must match elements of the constants vector
//first elements of constants vector must match elements of equilibriumComponentConcentrations vector
//first elements of equilibriumComponentConcentrations vector must match elements of totalComponentConcentrations vector
// the last component is a special component: the solvent. It does not have an associated mass balance equation and its activity is either set to 1
// (in which case it is a fixed activity component) or computed using Raoult's law


function EquilibriumCalculator(options) {
    // Model parameters:
    // solutionSpeciesConstants
    // solutionSpeciesCoefficients
    // solutionSpeciesCharges
    // solidSpeciesConstants
    // solidSpeciesCoefficients

    // Independent variables
    // fixedTotalComponentConcentrations
    // componentActivities
    // ionicStrength

    // Input constraints
    // totalConcentrations.length + fixedConcentrations.length must equal the number of columns in coefficients

    var concScaling, i, j;
    if(options instanceof EquilibriumCalculator) {
        var eq = options;
        this.rnd = eq.rnd;
        this.maxGuesses = eq.maxGuesses;
        this.solutionSpeciesConstants = eq.getSolutionEquilibriumConstants();
        this.solutionSpeciesCoefficients = eq.getSolutionSpeciesCoefficients();
        this.solutionSpeciesCharges = eq.getSolutionSpeciesCharges();
        this.solidSpeciesConstants = eq.getSolidEquilibriumConstants();
        this.solidSpeciesCoefficients = eq.getSolidSpeciesCoefficients();
        this.fixedTotalComponentConcentrations = eq.getFixedTotalConcentrations();
        this.componentActivities = eq.getComponentActivities();
        this.ionicStrength = eq.getIonicStrength();

        this.solidSpeciesConcentrations = eq.getSolidsConcentrations();

        this.solutionSpeciesConcentrations = eq.getSolutionSpeciesConcentrations();

        this.nSolids = eq.getNumberOfSolids();
        this.nSolutionSpecies = eq.getNumberOfSolutionSpecies();
        this.nComponents = eq.getNumberOfComponents();
        this.nFixedTotalConcentrations = eq.getNumberOfUnfixedComponents();

        this.concentrationScaling = initialize1DArray(this.nFixedTotalConcentrations);

        for (i = 0; i < this.nFixedTotalConcentrations; i++) {
            this.concentrationScaling[i] = 1.0;
            for (j = 0; j < this.nSolutionSpecies; j++) {
                if (this.solutionSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = 1.0 / Math.pow(this.solutionSpeciesConstants[j], 1.0 / this.solutionSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
            for (j = 0; j < this.nSolids; j++)
            if (this.solidSpeciesCoefficients[j][i] != 0.0) {
                concScaling = Math.pow(this.solidSpeciesConstants[j], 1.0 / this.solidSpeciesCoefficients[j][i]);
                if (concScaling < this.concentrationScaling[i])
                    this.concentrationScaling[i] = concScaling;
            }
        }
    }
    else {
        //initiate equilibrium constants, coefficients, total concentrations, and number of solids/precipitation rxns from input
        optionsAsProperties(this, options);
        if(!this.maxGuesses) this.maxGuesses = 1000;
        if(typeof options.randomGenerator === 'function') {
            this.rnd = options.randomGenerator
        }
        else if(Array.isArray(options.randomGenerator)) {
            if(options.randomGenerator[0] === 'default') {
                this.rnd = Math.random;
            }
            else if(options.randomGenerator[0] === 'seed') {
                this.rnd = rndWithSeed(options.randomGenerator[1] || 0);
            }
            else if(options.randomGenerator[0] === 'constant')
                this.rnd = constantRandom(options.randomGenerator[1] || 0.5)
        }
        else {
            if(options.randomGenerator === 'default')
                this.rnd = Math.random;
            else if(options.randomGenerator === 'seed')
                this.rnd = rndWithSeed(0);
            else if(options.randomGenerator === 'constant') {
                this.rnd = constantRandom(0.5);
            }
        }

        if(this.rnd === undefined && options.randomGenerator !== undefined) {
            console.warn('Unknown randomGenerator option, falling back to default random generator');
            this.rnd = Math.random;
        }
        else if(this.rnd === undefined) {
            this.rnd = Math.random;
        }


        this.nSolutionSpecies = this.solutionCoefficients.length;
        this.nComponents = this.solutionCoefficients[0].length;
        this.nSolids = this.precipitationConstants.length;
        this.nFixedTotalConcentrations = this.totalConcentrations.length;

        this.componentActivities = initialize1DArray(this.nComponents);
        this.solutionSpeciesConstants = this.solutionConstants;
        this.solutionSpeciesCharges = this.solutionSpeciesCharges;
        this.solutionSpeciesCoefficients = this.solutionCoefficients;
        this.solidSpeciesConstants = this.precipitationConstants;
        this.solidSpeciesCoefficients = this.precipitationCoefficients;
        this.fixedTotalComponentConcentrations = this.totalConcentrations;
        this.solidSpeciesConcentrations = initialize1DArray(this.nSolids);
        this.solutionSpeciesConcentrations = initialize1DArray(this.nSolutionSpecies);
        this.ionicStrength = 0;

        // Initiate all solids to zero
        for (i = 0; i < this.nSolids; i++) {
            this.solidSpeciesConcentrations[i] = 0.0;
        }

        this.concentrationScaling = initialize1DArray(this.nFixedTotalConcentrations);

        // compute the concentration scaling factors
        for (i = 0; i < this.nFixedTotalConcentrations; i++) {
            this.concentrationScaling[i] = 1.0;
            for (j = 0; j < this.nSolutionSpecies; j++) {
                if (this.solutionSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = 1.0 / Math.pow(this.solutionSpeciesConstants[j], 1.0 / this.solutionSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
            for (j = 0; j < this.nSolids; j++) {
                if (this.solidSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = Math.pow(this.solidSpeciesConstants[j], 1.0 / this.solidSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
        }

        //store fixed component activities at the end of the array of component activities (leave last for solvent)
        for (i = this.nFixedTotalConcentrations; i < this.nComponents - 1; i++) {
            this.componentActivities[i] = this.fixedActivities[(i - this.nFixedTotalConcentrations)];
        }
        //initial guess of variable component activities, solvent activity and ionic strength
        guess(this, true, false);
    }
}

// equilibrium concentrations of all soluble species and amount of each solid precipitated per litter of solution.
// solvent is an exception: it's activity is returned instead
EquilibriumCalculator.prototype.getComponentActivities = function() {
    return this.componentActivities.slice(0, this.nComponents);
};

EquilibriumCalculator.prototype.finalConcentrations = function() {
    var result = this.solutionSpeciesConcentrations.slice(0, this.nSolutionSpecies + this.nSolids);
    for (var i = 0; i < this.nSolids; i++) {
        result[(this.nSolutionSpecies + i)] = this.solidSpeciesConcentrations[i];
    }
    result[this.nComponents - 1] = this.componentActivities[this.nComponents - 1];
    return result;
};

EquilibriumCalculator.prototype.getSolutionSpeciesCoefficients = function() {
    return deepCopy(this.solutionSpeciesCoefficients, this.nSolutionSpecies, this.nComponents);
};



EquilibriumCalculator.prototype.getIonicStrength = function() {
    return this.ionicStrength;
};

//Return fixed total component concentrations
EquilibriumCalculator.prototype.getFixedTotalConcentrations = function() {
    return this.fixedTotalComponentConcentrations.slice(0, this.nFixedTotalConcentrations);
};

EquilibriumCalculator.prototype.getSolutionEquilibriumConstants = function() {
    return this.solutionSpeciesConstants.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getSolidEquilibriumConstants = function() {
    return this.solidSpeciesConstants.slice(0 , this.nSolids);
};

EquilibriumCalculator.prototype.getSolutionSpeciesCharges = function() {
    return this.solutionSpeciesCharges.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getSolidSpeciesCoefficients = function() {
    return deepCopy(this.solidSpeciesCoefficients, this.nSolids, this.nComponents);
};

EquilibriumCalculator.prototype.getSolidsConcentrations = function() {
    return this.solidSpeciesConcentrations.slice(0, this.nSolids);
};

EquilibriumCalculator.prototype.getSolutionSpeciesConcentrations = function() {
    return this.solutionSpeciesConcentrations.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getNumberOfSolutionSpecies = function() {
    return this.nSolutionSpecies;
};

EquilibriumCalculator.prototype.getNumberOfSolids = function() {
    return this.nSolids;
};

EquilibriumCalculator.prototype.getNumberOfSpecies = function() {
    return this.nSolids + this.nSolutionSpecies;
};

EquilibriumCalculator.prototype.getNumberOfComponents = function() {
    return this.nComponents;
};

EquilibriumCalculator.prototype.getNumberOfUnfixedComponents = function() {
    return this.nFixedTotalConcentrations;
};

EquilibriumCalculator.prototype.solutionSpeciesActivities = function()
{
    var result = initialize1DArray(this.nSolutionSpecies);
    //initialize non-component species activities to their formation constant
    var i, j;
    for (i = this.nComponents; i < this.nSolutionSpecies; i++) {
        result[i] = this.solutionSpeciesConstants[i];
    }
    for (i = 0; i < this.nComponents; i++) { //component activities are read directly from componentActivities array
        result[i] = this.componentActivities[i];
        for (j = this.nComponents; j < this.nSolutionSpecies; j++) { //non-component species activities are calculated from equilibrium constant expressions
            result[j] *= Math.pow(this.componentActivities[i], this.solutionSpeciesCoefficients[j][i]);
        }
    }
    return result;
};
//activity coefficients are computed using Davies' equation with A=0.5085 M^-1/2 (valid for water at 25°C)
//note that activity coefficient of solvent has no meaning
EquilibriumCalculator.prototype.solutionSpeciesActivityCoefficients = function()
{
    var result = initialize1DArray(this.nSolutionSpecies);
    var exponentialCoefficient = Math.sqrt(this.ionicStrength);
    exponentialCoefficient = (exponentialCoefficient / (1.0 + exponentialCoefficient) - 0.3 * this.ionicStrength) * -0.5085;
    for (var i = 0; i < this.nSolutionSpecies; i++) {
        result[i] = Math.exp(exponentialCoefficient * Math.pow(this.solutionSpeciesCharges[i], 2.0));
    }
    return result;
};

// note that species concentration value of solvent cannot be computed by this method, but we don't really care about it pretty much by definition.
// It is set to 0 to make sure that it is not mistakenly used in any balance
EquilibriumCalculator.prototype.calculateSolutionSpeciesConcentrations = function(correctActivities) {
    this.solutionSpeciesConcentrations = this.solutionSpeciesActivities();
    if (correctActivities) {
        var activityCoefficients = this.solutionSpeciesActivityCoefficients();
        for (var i = 0; i < this.nSolutionSpecies; i++) {
            this.solutionSpeciesConcentrations[i] /= activityCoefficients[i];
        }
        this.solutionSpeciesConcentrations[(this.nComponents - 1)] = 0.0;
    }
};

//computes the solubility products of all solid species
EquilibriumCalculator.prototype.solubilityProducts = function() {
    var result = initialize1DArray(this.nSolids);
    for (var i = 0; i < this.nSolids; i++) {
        result[i] = 1.0;
        for (var j = 0; j < this.nComponents; j++) {
            result[i] *= Math.pow(this.componentActivities[j], this.solidSpeciesCoefficients[i][j]);
        }
    }
    return result;
};

//computes the ratios between each solid's solubility product and the corresponding solubility constant
EquilibriumCalculator.prototype.saturationIndices = function()
{
    var  result = this.solubilityProducts();
    for (var i = 0; i < this.nSolids; i++) {
        result[i] /= this.solidSpeciesConstants[i];
    }
    return result;
};

//Total concentrations of ALL components but the solvent
//Computed from current activities, not read from fixedTotalComponentConcentrations
EquilibriumCalculator.prototype.totalConcentrations = function()
{
    return product(this.solutionSpeciesConcentrations, this.solutionSpeciesCoefficients, this.nSolutionSpecies, this.nComponents - 1);
};

//sets equilibrium concentration of a component
// WARNING: does not fix the given equilibrium concentration, after assignment the system iterates to equilibrium and will change the
// assigned component concentration unless it was already fixed at construction
EquilibriumCalculator.prototype.setEquilibriumActivity = function(component, value) {
    this.componentActivities[component] = value;
};

//sets the amount of a solid precipitated per litter of solution
EquilibriumCalculator.prototype.setPrecipitateConcentration = function(solid, value) {
    this.solidSpeciesConcentrations[solid] = value;
};

//set the total concentration of a component. Only allowed on components with total concentration fixed at construction
EquilibriumCalculator.prototype.setTotalConcentration = function(component, value)
{
    this.fixedTotalComponentConcentrations[component] = value;
    if (value == 0.0)
    this.componentActivities[component] = 0.0;
};

//sets the value of an equilibrium constant. Concentration scaling factors for equilibrium concentration guesses are updated after assignment.
EquilibriumCalculator.prototype.setSolutionEquilibriumConstant = function(constant, value) {
    this.solutionSpeciesConstants[constant] = value;
    var concScaling;
    for (var i = 0; i < this.nFixedTotalConcentrations; i++) {
        if (this.solutionSpeciesCoefficients[constant][i] != 0.0) {
            concScaling = 1.0 / Math.pow(value, 1.0 / this.solutionSpeciesCoefficients[constant][i]);
            if (concScaling < this.concentrationScaling[i])
                this.concentrationScaling[i] = concScaling;
        }
    }
};

//sets the value of an equilibrium constant. Concentration scaling factors for equilibrium concentration guesses are updated after assignment.
EquilibriumCalculator.prototype.setSolidEquilibriumConstant = function(constant, value)
{
    this.solidSpeciesConstants[constant] = value;
    var concScaling;
    for (var i = 0; i < this.nFixedTotalConcentrations; i++) {
        if (this.solidSpeciesCoefficients[constant][i] != 0.0) {
            concScaling = 1.0 / Math.pow(value, 1.0 / this.solidSpeciesCoefficients[constant][i]);
            if (concScaling < this.concentrationScaling[i])
                this.concentrationScaling[i] = concScaling;
        }
    }
};

EquilibriumCalculator.prototype.setIonicStrength = function(ionicStrength) {
    this.ionicStrength = ionicStrength;
};


EquilibriumCalculator.prototype.calculatedIonicStrength = function() {
    var result = 0.0;
    for (var i = 0; i < this.nSolutionSpecies; i++) {
        result += Math.pow(this.solutionSpeciesCharges[i], 2.0) * this.solutionSpeciesConcentrations[i];
    }
    return result / 2.0;
};

//shifts all solid species towards solution
//NOTE: what am i using this for?
EquilibriumCalculator.prototype.disolveAll = function(correctActivities) {
    for (var j = 0; j < this.nSolids; j++)
    disolve(this, j, correctActivities);
};

//remove the species itself
EquilibriumCalculator.prototype.removeSolutionSpecies = function(species) {
    this.nSolutionSpecies -= 1;
    var i,j;
    //if species is a component, remove all its derived species and remove it from components and coefficients arrays
    for (i = species; i < this.nSolutionSpecies; i++) {
        this.solutionSpeciesCharges[i] = this.solutionSpeciesCharges[(i + 1)];
        this.solutionSpeciesConcentrations[i] = this.solutionSpeciesConcentrations[(i + 1)];
        this.solutionSpeciesConstants[i] = this.solutionSpeciesConstants[(i + 1)];
        this.solutionSpeciesCoefficients[i] = this.solutionSpeciesCoefficients[(i + 1)];
    }

    if (species < this.nComponents) {
        //remove derived solution species
        for (i = 0; i < this.nSolutionSpecies; i++) {
            if (this.solutionSpeciesCoefficients[i][species] != 0.0) {
                this.removeSolutionSpecies(i);
                i--;
            }
            else {
                //remove from coefficients of solution reactions
                for (j = species; j < this.nComponents - 1; j++) {
                    this.solutionSpeciesCoefficients[i][j] = this.solutionSpeciesCoefficients[i][j + 1];
                }
            }
        }
        //remove derived solid species
        for (i = 0; i < this.nSolids; i++) {
            if (this.solidSpeciesCoefficients[i][species] != 0.0) {
                this.removeSolid(i);
                i--;
            }
            else { //remove from coefficients of solid reactions
                for (j = species; j < this.nComponents - 1; j++) {
                    this.solidSpeciesCoefficients[i][j] = this.solidSpeciesCoefficients[i][(j + 1)];
                }
            }
        }

        //remove the component itself
        this.nComponents -= 1;
        if (species < this.nFixedTotalConcentrations) {
            //if species is an unfixed component (unfixed activity) remove it from total concentration array as well
            this.nFixedTotalConcentrations -= 1;
            for (i = species; i < this.nFixedTotalConcentrations; i++) {
                this.fixedTotalComponentConcentrations[i] = this.fixedTotalComponentConcentrations[i + 1];
                this.componentActivities[i] = this.componentActivities[i + 1];
            }
            for (i = this.nFixedTotalConcentrations; i < this.nComponents; i++)
                this.componentActivities[i] = this.componentActivities[(i + 1)];
        }
        else
        {
            for (i = species; i < this.nComponents; i++)
                this.componentActivities[i] = this.componentActivities[(i + 1)];
        }
    }
};

EquilibriumCalculator.prototype.removeSolid = function(solid) {
    this.nSolids -= 1;
    if (this.nSolids > 0) {
        for (var i = solid; i < this.nSolids; i++) {
            this.solidSpeciesConcentrations[i] = this.solidSpeciesConcentrations[(i + 1)];
            this.solidSpeciesConstants[i] = this.solidSpeciesConstants[(i + 1)];
            this.solidSpeciesCoefficients[i] = this.solidSpeciesCoefficients[(i + 1)];
        }
    }
    else {
        this.solidSpeciesCoefficients = [[]];
        this.solidSpeciesConcentrations = [];
        this.solidSpeciesConstants = [];
    }
};

EquilibriumCalculator.prototype.addSolutionSpecies = function(){
};

EquilibriumCalculator.prototype.addSolid = function() {
};

EquilibriumCalculator.prototype.addComponent = function() {
};

//returns the equilibriumCalculator object comprising only components with non-zero total concentrations and their derived species
EquilibriumCalculator.prototype.removeZeroConcentrations = function()
{
    var result = new EquilibriumCalculator(this);
    for (var i = 0; i < result.nFixedTotalConcentrations; i++) {
        if (result.fixedTotalComponentConcentrations[i] == 0.0) {
            result.removeSolutionSpecies(i);
            i--;
        }
    }
    return result;
};

EquilibriumCalculator.prototype.calculate = function(correctActivities, fixedIonicStrength, maxIterations, precision, maxGuesses) {
    if(arguments.length === 2) {
        return this.calculate(correctActivities, fixedIonicStrength, 99999, this.maxGuesses, 0.0001);
    }
    else if(arguments.length === 4) {
        return this.calculate(correctActivities, fixedIonicStrength, maxIterations, this.maxGuesses, precision);
    }
    else if(arguments.length === 5) {
        var tmp; tmp = maxGuesses;
        maxGuesses = precision;
        precision = tmp;

        var nGuesses = 0, i, result;
        if (!correctActivities) {
            this.componentActivities[(this.nComponents - 1)] = 1.0;
        }
        while (nGuesses < maxGuesses) {
            try {
                nGuesses++;
                result = calculateOnePoint(this, correctActivities, fixedIonicStrength, maxIterations, precision);
                if (result == maxIterations) {
                    //console.log("maximum number of iterations reached, result is not trustworthy");
                }
                //console.log("Solution found will now be checked");
                while ((hasNegative(this.finalConcentrations(), this.nSolutionSpecies + this.nSolids)) && (nGuesses < maxGuesses)) {
                    nGuesses++;
                    //console.log("Inadequate solution (negative, infinite, or not a number), computing with the " + nGuesses + "th  guess");

                    guess(this, correctActivities, fixedIonicStrength);
                    result = calculateOnePoint(this, correctActivities, fixedIonicStrength, maxIterations, precision);
                    if (result == maxIterations) {
                        //console.log("maximum number of iterations reached, result is not trustworthy");
                    }
                    //console.log("Solution found will now be checked");
                }
                if (hasNegative(this.finalConcentrations(), this.nSolutionSpecies + this.nSolids)) {
                    return "No successful guess";
                }
                if (result < maxIterations) {
                    return "Adequate solution";
                }
                return "Last guess failed to converge, results might not be valid!";
            } catch (e) {
                if (nGuesses < maxGuesses) {
                    console.log(e.stack);
                    console.log("Error occurred during calculation (" + e + "), retrying with the " + (nGuesses + 1) + "th guess");
                    for (i = 0; i < this.nSolids; i++) {
                        this.solidSpeciesConcentrations[i] = 0.0;
                    }
                    guess(this, correctActivities, fixedIonicStrength);
                }

            }

        }

        console.log("Error");
        return "Error";
    }
};



// Private =======================================================

//shifts the whole precipitated mass of a solid species towards solution
//all dissolved solid is put in the form of its components. Naturally, leaves solution unbalanced
//the corresponding activities are corrected using the current ionic strength, ionic strength is not corrected for the increased solution species concentrations.
//WARNING: consequences of using on an unbalanced solution are unknown. Privatized just in case.
function disolve(ctx, solid, correctActivities) {
    for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        ctx.solutionSpeciesConcentrations[i] +=
            ctx.solidSpeciesConcentrations[solid] * ctx.solidSpeciesCoefficients[solid][i];
        ctx.componentActivities[i] = ctx.solutionSpeciesConcentrations[i];
    }
    ctx.solidSpeciesConcentrations[solid] = 0.0;
    if (correctActivities) {
        var activityCoefficients = ctx.solutionSpeciesActivityCoefficients();
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++)
            ctx.componentActivities[i] /= activityCoefficients[i];
    }
}

//computes solvent activity using an approximation based on raoult's law (same used by phreeqc)
function calculatedSolventActivity(ctx) {
    var result = 0.0;
    for(var i=0; i<ctx.solutionSpeciesConcentrations.length ; i++) {
        result += ctx.solutionSpeciesConcentrations[i];
    }
    return 1.0 - 0.017 * result;
}

//randomly guess equilibrium activities for the system's components and updates species concentrations, ionic strength, and solvent activity
function guess(ctx, correctActivities, fixedIonicStrength)
{
    var factor = ctx.rnd();
    //console.log('factor', factor);
    var i;
    //guess variable component activities
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
    ctx.componentActivities[i] = (ctx.fixedTotalComponentConcentrations[i] * Math.pow(ctx.concentrationScaling[i], factor));
}
    //guess ionic strength as that computed from species concentrations computed assuming ionic strength = zero and solvent activity = 1
    //guess solvent activity as that computed from species concentrations computed assuming ionic strength = zero and solvent activity = 1
    ctx.componentActivities[(ctx.nComponents - 1)] = 1.0;
    if (correctActivities) {
        if (!fixedIonicStrength) {
            ctx.ionicStrength = 0.0;
        }
        ctx.calculateSolutionSpeciesConcentrations(correctActivities);
        if (!fixedIonicStrength) {
            ctx.ionicStrength = ctx.calculatedIonicStrength();
        }
        ctx.componentActivities[(ctx.nComponents - 1)] = calculatedSolventActivity(ctx);
    }

    for (i = 0; i < ctx.nSolids; i++)
    ctx.solidSpeciesConcentrations[i] = 0.0;
}

// balance for solution components, given solid species, and ionic strength if desired
// balance equations for solution components with unfixed activities but fixed total concentrations is the difference between
// the fixed total concentration and the total concentration computed from the current equilibrium concentrations
// balance equation for ionic strength is the difference between the current ionic strength and that computed from current species concentrations
// balance equation for solids is the difference between the solubility constant and the current solubility product
function balance(ctx, correctActivities, fixedIonicStrength, solids) {
    //sub-optimal code for the sake of readability
    var solidsLength = solids.length;
    var balanceError = [];
    // initialization and activity correction-contingent balances
    if (correctActivities)
    {
        if (fixedIonicStrength) {
            balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength + 1);
        }
        else {
            balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength + 2);
            //balance of ionic strength
            balanceError[(ctx.nFixedTotalConcentrations + solidsLength + 1)] = (ctx.ionicStrength - ctx.calculatedIonicStrength());
        }
        //balance of solvent activity
        balanceError[(ctx.nFixedTotalConcentrations + solidsLength)] = (ctx.componentActivities[(ctx.nComponents - 1)] - calculatedSolventActivity(ctx));
    }
    else {
        balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength);
    }
    //balance of solution components
    //substract solution species
    balanceError = sum(balanceError, minus(ctx.fixedTotalComponentConcentrations,
        product(ctx.solutionSpeciesConcentrations, ctx.solutionSpeciesCoefficients, ctx.nSolutionSpecies, ctx.nFixedTotalConcentrations),
        ctx.nFixedTotalConcentrations), ctx.nFixedTotalConcentrations, true);

    //substract solid species
    if (ctx.nSolids > 0) {
        balanceError = minus(balanceError,
            product(ctx.solidSpeciesConcentrations, ctx.solidSpeciesCoefficients, ctx.nSolids, ctx.nFixedTotalConcentrations),
            ctx.nFixedTotalConcentrations, true);
    }

    //balance of solids
    var solubilityProducts = ctx.solubilityProducts();
    var solidIndex = ctx.nFixedTotalConcentrations;
    for (var i=0; i<solids.length; i++) {
        balanceError[solidIndex] = (ctx.solidSpeciesConstants[solids[i]] - solubilityProducts[solids[i]]);
        solidIndex++;
    }

    return balanceError;
}

function componentComponentDerivatives(ctx) {
    var i, j,k;
    var result = initialize2DArray(ctx.nFixedTotalConcentrations, ctx.nFixedTotalConcentrations);
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (j = 0; j < ctx.nFixedTotalConcentrations; j++) {
            result[i][j] = 0.0;
            for (k = 0; k < ctx.nSolutionSpecies; k++) {
                result[i][j] += ctx.solutionSpeciesCoefficients[k][j] * ctx.solutionSpeciesCoefficients[k][i] * ctx.solutionSpeciesConcentrations[k];
            }
            result[i][j] /= ctx.componentActivities[i];
        }
    }
    return result;
}

function componentIonicStrengthDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i, j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        result[i] = 0.0;
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCoefficients[j][i] *
                ctx.solutionSpeciesConcentrations[j];
        }
        result[i] = (result[i] * 0.5085 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3));
    }
    return result;
}

function componentSolidDerivatives(ctx, solids) {
    var result = initialize2DArray(solids.length, ctx.nFixedTotalConcentrations);
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            result[solidIndex][i] = ctx.solidSpeciesCoefficients[solids[j]][i];
        }
        solidIndex++;
    }
    return result;
}

function componentSolventDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var solventActivity = ctx.componentActivities[(ctx.nComponents - 1)];
    for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (var j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCoefficients[j][i] * ctx.solutionSpeciesCoefficients[j][(ctx.nComponents - 1)] * ctx.solutionSpeciesConcentrations[j];
        }
        result[i] /= solventActivity;
    }
    return result;
}

function solidComponentDerivatives(ctx, solids) {
    var result = initialize2DArray(ctx.nFixedTotalConcentrations, solids.length);
    var solubilityProducts = ctx.solubilityProducts();
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            result[i][solidIndex] = (solubilityProducts[solids[j]] * ctx.solidSpeciesCoefficients[solids[j]][i] / ctx.componentActivities[i]);
        }
        solidIndex++;
    }
    return result;
}

function solidSolventDerivatives(ctx, solids) {
    var result = initialize1DArray(solids.length);
    var solubilityProducts = ctx.solubilityProducts();
    var solventActivity = ctx.componentActivities[(ctx.nComponents - 1)];
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        result[solidIndex] = (ctx.solidSpeciesCoefficients[solids[j]][(ctx.nComponents - 1)] * solubilityProducts[solids[j]] / solventActivity);
        solidIndex++;
    }
    return result;
}

function ionicStrengthComponentDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i,j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        result[i] = 0.0;
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCoefficients[j][i] *
                ctx.solutionSpeciesConcentrations[j];
        }
        result[i] /= 2.0 * ctx.componentActivities[i];
    }
    return result;
}

function ionicStrengthIonicStrengthDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 4.0) * ctx.solutionSpeciesConcentrations[i];
    }
    result = result * 0.25425 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3) - 1.0;
    return result;
}

function ionicStrengthSolventDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 2.0) * ctx.solutionSpeciesCoefficients[i][(ctx.nComponents - 1)] * ctx.solutionSpeciesConcentrations[i];
    }
    return result / (ctx.componentActivities[(ctx.nComponents - 1)] * 2.0);
}

function solventComponentsDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i,j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] += ctx.solutionSpeciesCoefficients[j][i] * ctx.solutionSpeciesConcentrations[j];
        }
        result[i] = (result[i] * 0.017 / ctx.componentActivities[i]);
    }
    return result;
}

function solventIonicStrengthDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 2.0) * ctx.solutionSpeciesConcentrations[i];
    }
    return result * -0.017 * 0.5085 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3);
}

function solventSolventDerivative(ctx) {
    var result = 0.0;
    for (var i = 0; i < ctx.nSolutionSpecies; i++) {
        result += ctx.solutionSpeciesConcentrations[i];
    }
    return -1.0 - result * 0.017;
}

// Jacobian of balance
// actually it returns jacobian * -1
function balanceJacobian(ctx, correctActivities, fixedIonicStrength, solids) {
    //derivatives are calculated using the adequate methods (or trivially if that is the case) and then copied in the adequate blocks of the jacobian
    var componentComponent = componentComponentDerivatives(ctx);
    var componentSolid = componentSolidDerivatives(ctx, solids);
    var solidComponent = solidComponentDerivatives(ctx, solids);
    var solidsLength = solids.length;
    var jacobian = [[]];
    var i, j;

    //reserve the correct amount of space for the jacobian and compute activity correction-contingent elements
    if (correctActivities)
    {
        if (fixedIonicStrength) {
            jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength + 1,ctx.nFixedTotalConcentrations + solidsLength + 1);
        }
        else {
            jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength + 2,ctx.nFixedTotalConcentrations + solidsLength + 2);
            var ionicComponent = ionicStrengthComponentDerivatives(ctx);
            var componentIonic = componentIonicStrengthDerivatives(ctx);

            //copy ionic strength - component and component -ionic strength derivatives
            for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
                jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicComponent[i];
                jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][i] = componentIonic[i];
            }

            //copy ionic strength - solid and solid - ionic strength derivatives
            for (i = 0; i < solidsLength; i++) {
                jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = 0.0;
                jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][i] = 0.0;
            }

            //ionic strength - ionic strength derivative
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicStrengthIonicStrengthDerivative(ctx);

            //ionic strength - solvent and solvent - ionic strength derivatives
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][(ctx.nFixedTotalConcentrations + solidsLength)] = solventIonicStrengthDerivative(ctx);
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicStrengthSolventDerivative(ctx);
        }
        var solventComponent = solventComponentsDerivatives(ctx);
        var componentSolvent = componentSolventDerivatives(ctx);
        var solidSolvent = solidSolventDerivatives(ctx, solids);

        //copy solvent-component and component-solvent derivatives
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength)] = solventComponent[i];
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][i] = componentSolvent[i];
    }

        //copy solid-solvent derivatives and set solvent-solid derivatives to zero
        for (i = 0; i < solidsLength; i++) {
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(i + ctx.nFixedTotalConcentrations)] = solidSolvent[i];
        jacobian[(i + ctx.nFixedTotalConcentrations)][(ctx.nFixedTotalConcentrations + solidsLength)] = 0.0;
    }
        //solvent - solvent derivative
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(ctx.nFixedTotalConcentrations + solidsLength)] = solventSolventDerivative(ctx);
    }
    else {
        jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength, ctx.nFixedTotalConcentrations + solidsLength);
    }

    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        //copy component - component derivatives
        for (j = i; j < ctx.nFixedTotalConcentrations; j++) {
        jacobian[i][j] = componentComponent[i][j];
        jacobian[j][i] = componentComponent[j][i];
    }

        //copy component - solid and solid - component derivatives
        for (j = 0; j < solidsLength; j++) {
        jacobian[i][(ctx.nFixedTotalConcentrations + j)] = solidComponent[i][j];
        jacobian[(ctx.nFixedTotalConcentrations + j)][i] = componentSolid[j][i];
    }
    }

    //copy solid - solid derivatives (zero-valued)
    for (i = 0; i < solidsLength; i++) {
        for (j = i; j < solidsLength; j++) {
            jacobian[(ctx.nFixedTotalConcentrations + i)][(ctx.nFixedTotalConcentrations + j)] = 0.0;
            jacobian[(ctx.nFixedTotalConcentrations + j)][(ctx.nFixedTotalConcentrations + i)] = 0.0;
        }
    }
    return jacobian;
}

function equilibrateNoSolids(ctx, correctActivities, fixedIonicStrength, maxIterations, precision) {
    var noSolids = [];
    return equilibrate(ctx, correctActivities, fixedIonicStrength, noSolids, maxIterations, precision);
}

//WARNING unwarranted behavior if correctActivities=false and fixedIonicStrength=true. Prevent such ocurrence in the public method
//Returns the number of iterations run
function equilibrate(ctx, correctActivities, fixedIonicStrength, solids, maxIterations, precision) {
    if(arguments.length <= 5) return equilibrateNoSolids.apply(null, arguments);
    if (hasZero(ctx.fixedTotalComponentConcentrations, ctx.nFixedTotalConcentrations)) {
        var reducedSystem = ctx.removeZeroConcentrations();
        var result = equilibrate(reducedSystem, correctActivities, fixedIonicStrength, solids, maxIterations, precision);

        //copy solution species concentrations
        var i, j,k = 0, present;

        var solutionConcentrations = reducedSystem.getSolutionSpeciesConcentrations();
        for (i = 0; i < ctx.nSolutionSpecies; i++) {
            present = true;
            for (j = 0; j < ctx.nComponents; j++) { //nFixedTotalConcentrations?
                if ((ctx.solutionSpeciesCoefficients[i][j] != 0.0) && (ctx.componentActivities[j] == 0.0)) {
                    present = false;
                    ctx.solutionSpeciesConcentrations[i] = 0.0;
                    break;
                }
            }
            if (present) {
                ctx.solutionSpeciesConcentrations[i] = solutionConcentrations[k];
                k++;
            }
        }

        //copy solid species concentrations
        k = 0;
        var solidConcentrations = reducedSystem.getSolidsConcentrations();
        for (i = 0; i < ctx.nSolids; i++) {
            present = true;
            for (j = 0; j < ctx.nComponents; j++) {
                if ((ctx.solidSpeciesCoefficients[i][j] != 0.0) && (ctx.componentActivities[j] == 0.0)) {
                    present = false;
                    ctx.solidSpeciesConcentrations[i] = 0.0;
                    break;
                }
            }
            if (present) {
                ctx.solidSpeciesConcentrations[i] = solidConcentrations[k];
                k++;
            }
        }

        //copy component activities
        var nonZeroEquilibriumActivities = reducedSystem.getComponentActivities();
        k = 0;
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            if (ctx.fixedTotalComponentConcentrations[i] != 0.0) {
                ctx.componentActivities[i] = nonZeroEquilibriumActivities[k];
                k++;
            }
        }

        //copy ionic strength
        if (correctActivities) {
            ctx.ionicStrength = reducedSystem.getIonicStrength();
        }
        return result;
    }

    var iterations = 1;
    var solidsLength = solids.length;

    //species concentrations must be updated before balancing
    ctx.calculateSolutionSpeciesConcentrations(correctActivities);
    var totalError = balance(ctx, correctActivities, fixedIonicStrength, solids);

    //last condition in the while statement (second term of the or) may be unnecessary... or, on the contrary, a similar condition on solution species may be necessary
    while ((iterations <= maxIterations) && (maximumRelativeError(ctx, totalError, solids, correctActivities, fixedIonicStrength) > precision))
    {
        var jacobian = new Matrix(balanceJacobian(ctx, correctActivities, fixedIonicStrength, solids));
        var inverseJacobian = jacobian.inverse().to2DArray();
        var shifts;
        //computation of shift vector with an adequately sized product and activity correction-contingent shifts
        if (correctActivities)
        {
            if (fixedIonicStrength) {
                shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength + 1, ctx.nFixedTotalConcentrations + solidsLength + 1);
            }
            else {
                shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength + 2, ctx.nFixedTotalConcentrations + solidsLength + 2);
                //shift ionic strength
                ctx.ionicStrength += shifts[(ctx.nFixedTotalConcentrations + solidsLength + 1)];
            }

            //shift solvent activity
            ctx.componentActivities[(ctx.nComponents - 1)] += shifts[(ctx.nFixedTotalConcentrations + solidsLength)];
        }
        else {
            shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength, ctx.nFixedTotalConcentrations + solidsLength);
        }

        //shift component activities
        ctx.componentActivities = sum(ctx.componentActivities, shifts, ctx.nFixedTotalConcentrations, true);

        var solidIndex = ctx.nFixedTotalConcentrations;
        for (i=0; i<solids.length; i++) {
        ctx.solidSpeciesConcentrations[solids[i]] += shifts[solidIndex];
        solidIndex++;
    }

        //update species concentrations
        ctx.calculateSolutionSpeciesConcentrations(correctActivities);
        totalError = balance(ctx, correctActivities, fixedIonicStrength, solids);
        iterations++;
    }
    if (iterations === 1) {
        //console.log("Equilibrium reached after " + iterations + " iterations");
        return iterations;
    }
    if (iterations > maxIterations) {
        //console.log("maximum number of iterations reached without convergence");
    }
    else {
        //console.log("Equilibrium reached after " + (iterations - 1) + " iterations");
    }
    return iterations - 1;
}

//relative error on total concentrations
function maximumRelativeError(ctx, errors, solids, correctActivities, fixedIonicStrength) {
    var  maxError = 0.0, i;

    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        maxError = Math.max(maxError, Math.abs(errors[i] / ctx.fixedTotalComponentConcentrations[i]));
    }
    var solidIndex = ctx.nFixedTotalConcentrations;

    //relative error on solid solubility products
    for (i=0; i<solids.length; i++) {
        maxError = Math.max(maxError, Math.abs(errors[solidIndex] / ctx.solidSpeciesConstants[solids[i]]));
        solidIndex++;
    }
    if (correctActivities) {
        //relative error on solvent activity
        maxError = Math.max(maxError, Math.abs(errors[solidIndex] / ctx.componentActivities[(ctx.nComponents - 1)]));
        if (!fixedIonicStrength) {
            //relative error on ionic strength
            maxError = Math.max(maxError, Math.abs(errors[(solidIndex + 1)] / ctx.ionicStrength));
        }
    }
    return maxError;
}

function mostInsoluble(ctx) {
    var saturationIndices = ctx.saturationIndices();
    var result = 0, i;
    for (i = 0; i < ctx.nSolids; i++) {
        if (saturationIndices[i] > saturationIndices[result]) {
            result = i;
        }
    }
    return result;
}

//returns the number of iterations in the last run of equilibrate (the one that ends with no oversaturated/insaturated solid) or
//maxIterations if maximum number of precipitation cycles was exausted
function calculateOnePoint(ctx, correctActivities, fixedIonicStrength, maxIterations, precision)
{
    var currentSolid = 0;
    var solidsToPrecipitate = [];
    var precipitationCycles = 0;
    var i;
    //console.log("Iterating solution towards equilibrium...");
    var result = equilibrate(ctx, correctActivities, fixedIonicStrength, solidsToPrecipitate, maxIterations, precision);

    if (ctx.nSolids > 0) {
        var saturationIndices = ctx.saturationIndices();

        //disolve all insaturated
        for (i = 0; i < ctx.nSolids; i++) {
            if ((ctx.solidSpeciesConcentrations[i] > 0.0) && (1.0 - saturationIndices[i] > precision)) {
                disolve(ctx, i, correctActivities);
            }
        }
        result = equilibrate(ctx,correctActivities, fixedIonicStrength, maxIterations, precision);

        saturationIndices = ctx.saturationIndices();
        currentSolid = mostInsoluble(ctx);

        while ((saturationIndices[currentSolid] - 1.0 > precision) && (precipitationCycles <= ctx.nSolids))
        {
            precipitationCycles++;
            //console.log("Solid " + currentSolid + " is over-saturated and will be included in the global balance");
            //console.log("Iterating the extended system towards equilibrium...");
            solidsToPrecipitate = solidsToPrecipitate.slice(0, solidsToPrecipitate.length + 1);
            solidsToPrecipitate[(solidsToPrecipitate.length - 1)] = currentSolid;
            equilibrate(ctx, correctActivities, fixedIonicStrength, solidsToPrecipitate, maxIterations, precision);
            saturationIndices = ctx.saturationIndices();
            for (i = 0; i < ctx.nSolids; i++) {
                if ((ctx.solidSpeciesConcentrations[i] > 0.0) && (1.0 - saturationIndices[i] > precision)) {
                    disolve(ctx, i, correctActivities);
                }
            }
            result = equilibrate(ctx, correctActivities, fixedIonicStrength, maxIterations, precision);
            saturationIndices = ctx.saturationIndices();

            currentSolid = mostInsoluble(ctx);
        }
    }

    if (precipitationCycles > ctx.nSolids) {
        //console.log("Solid phases could not be equilibrated with the solution");
        return maxIterations;
    }
    //console.log("All solid phases are now in equilibrium with the solution");
    return result;
}

function hasZero(arr, nElements) {
    var i;
    for (i = 0; i < nElements; i++) {
        if (arr[i] == 0.0) {
            return true;
        }
    }
    return false;
}

function hasNegative(arr, nElements) {
    for (var i = 0; i < nElements; i++) {
        if (arr[i] < 0.0 || arr[i] === Infinity || arr[i] === -Infinity || isNaN(arr[i]))
            return true;
    }
    return false;
}

function hasError(ctx, val, nElements) {
    if(argements.length === 1) {
        return (hasError(ctx.componentActivities, ctx.nComponents)) ||
            (hasError(getSolutionSpeciesConcentrations(), ctx.nSolutionSpecies)) ||
            (hasError(getSolidsConcentrations(), ctx.nSolids)) ||
            (hasError(getIonicStrength()));
    }
    if(arguments.length === 2) {
        return val === Infinity || val === -Infinity;
    }
    if(arguments.length === 3) {
        if(typeof val !== Array) return true;
        for (var i = 0; i < nElements; i++) {
            if (val[i] === Infinity || val[i] === -Infinity)
                return true;
        }
        return false;
    }

}

function product(a1,  a2, nRows, nColumns) {
    var result, i, j;
    if(Array.isArray(a1) && Array.isArray(a1[0])) {
        result = initialize1DArray(a1.length);
        for (i = 0; i < nRows; i++) {
            result[i] = 0.0;
            for (j = 0; j < nColumns; j++) {
                result[i] += a1[i][j] * a2[j];
            }
        }
    }
    else if(Array.isArray(a2) && Array.isArray(a2[0])) {
        result = initialize1DArray(a2[0].length);
        for (i = 0; i < nColumns; i++) {
            result[i] = 0.0;
            for (j = 0; j < nRows; j++) {
                result[i] += a2[j][i] * a1[j];
            }
        }
        return result;
    }

    return result;
}

function sum(v1, v2, nElements, inPlace) {
    var result;
    if(inPlace) {
        result = v1.slice();
    }
    else {
        result = initialize1DArray(v1.length);
    }
    for (var i = 0; i < nElements; i++) {
        result[i] = v1[i] + v2[i];
    }
    return result;
}

function minus(v1, v2, nElements, inPlace) {
    var result;
    if(inPlace) {
        result = v1.slice();
    }
    else {
        result = initialize1DArray(v1.length);
    }
    for (var i = 0; i < nElements; i++) {
        result[i] = v1[i] - v2[i];
    }
    return result;
}

function deepCopy(doubleArray, nRows, nCols) {
    var result = initialize1DArray(nRows);
    for(var i=0; i<doubleArray.length; i++) {
        result[i] = doubleArray[i].slice();
    }
    return result;
}

function optionsAsProperties(ctx, options) {
    for(var key in options) {
        ctx[key] = options[key];
    }
}

function initialize2DArray(nRow, nCol) {
    var result = new Array(nRow);
    for(var i=0; i<nRow; i++) {
        result[i] = initialize1DArray(nCol);
    }
    return result;
}

function initialize1DArray(n) {
    return Array.apply(null, new Array(n)).map(Number.prototype.valueOf,0);
}

function rndWithSeed(seed) {
    var mt = new mersenneTwister(seed);
    return mt.random.bind(mt);
}

function constantRandom(constant) {
    return function() {
        return constant;
    };
}

module.exports = EquilibriumCalculator;


/*****************
 ** WEBPACK FOOTER
 ** ./~/chem-equilibrium/src/index.js
 ** module id = 1
 ** module chunks = 0
 **/